import qs from "querystring";

function serializeQuery(query = {}) {
  return qs.stringify(query);
}

export default serializeQuery;



// WEBPACK FOOTER //
// ./utils/serializeQuery.js